import { TextKey } from '@mews/text-keys';

const countryCodeCheckoutStatements: Record<string, TextKey[]> = {
    CZ: [TextKey.LegalStatementOrderObligingToPay],
};

export const getCountryCodeCheckoutStatements = (countryCode: string): TextKey[] => {
    if (countryCodeCheckoutStatements?.[countryCode] == null) {
        return [];
    }

    return countryCodeCheckoutStatements[countryCode];
};
